import { Game } from './core/Game';

// 等待 DOM 加载完成
window.addEventListener('DOMContentLoaded', () => {
  const canvas = document.getElementById('game-canvas') as HTMLCanvasElement;
  const game = new Game(canvas);

  // 开始按钮事件
  const startButton = document.getElementById('start-button') as HTMLButtonElement;
  const overlay = document.getElementById('game-overlay') as HTMLDivElement;

  startButton.addEventListener('click', () => {
    overlay.classList.add('hidden');
    game.start();
  });

  // R 键重新开始
  window.addEventListener('keydown', (e) => {
    if (e.key === 'r' || e.key === 'R') {
      game.restart();
    }
  });
});
